import React from 'react';
import { IoArrowBackCircle } from 'react-icons/io5';
import { IconButton, Button } from '@mui/material';

const BackButton = ({ onClick, className }) => {
  return (
    <Button
      variant="contained"
      className={'bg-blueBg mb-2'}
      // color="primary"
      size="small"
      onClick={onClick}
      
    >
      <IoArrowBackCircle size={24} className='mr-1' /> Back
    </Button>
  );
};

export default BackButton;
